import React from 'react';
import './PrivacyPolicy.css';

export const PRIVACY_POLICY_VERSION = '2026-08-04';
const CONTACT_EMAIL = 'c.albuq78@gmail.com';

export function PrivacyPolicyContent() {
  return (
    <div className="pp-content">
      <p className="pp-updated">Última atualização: 04/08/2026</p>

      <p>
        O Life Assistant é um aplicativo pessoal de organização (saúde, agenda,
        alimentação, treino, finanças e e-mails) mantido por Cristiano
        Albuquerque. Esta política explica quais dados o app coleta, pra que
        usamos, com quem compartilhamos e quais direitos você tem sobre eles,
        conforme a Lei Geral de Proteção de Dados (LGPD).
      </p>

      <h3>1. Quem é o controlador dos dados</h3>
      <p>
        Cristiano Albuquerque, responsável pelo desenvolvimento e operação do
        Life Assistant. Contato para qualquer assunto sobre seus dados:{' '}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>

      <h3>2. Quais dados coletamos</h3>
      <p><b>Conta:</b> nome, e-mail e senha (guardada com hash — nunca em texto puro).</p>
      <p>
        <b>Dados que você conecta ou envia, todos opcionais:</b>
      </p>
      <ul>
        <li>Saúde e atividade física (passos, sono, frequência cardíaca, distância, treinos), se você conectar o app Health Auto Export do seu celular;</li>
        <li>Eventos de calendário, se você conectar o Atalho de Calendário do iPhone;</li>
        <li>Remetente, assunto e um trecho de e-mails das contas Gmail/Outlook que você conectar e escolher mostrar no painel;</li>
        <li>Notas do OneNote, se você conectar sua conta Microsoft;</li>
        <li>Composição corporal, quando você envia manualmente a planilha exportada da sua balança;</li>
        <li>Treinos de academia, cardápios e alergias alimentares que você cadastra ou pede pra IA sugerir;</li>
        <li>Objetivos pessoais e preferências (temas de notícia, data de nascimento, etc.) que você escreve nos campos do app;</li>
        <li>Sua própria chave de API da Anthropic, se você optar por cadastrar uma (fica salva no seu perfil, guardada da mesma forma que os demais dados acima — sem criptografia adicional).</li>
      </ul>
      <p>
        <b>Dados técnicos:</b> um cookie de sessão (necessário pra manter você
        logado), sem cookies de rastreamento ou publicidade de terceiros.
      </p>

      <h3>3. Para que usamos os dados</h3>
      <p>
        Exclusivamente para exibir essas informações organizadas no seu
        próprio painel, e para gerar as análises e sugestões por Inteligência
        Artificial que você pedir (análise semanal de saúde/treino, sugestão
        de treino, sugestão de cardápio). Também usamos seu e-mail para enviar
        a confirmação de cadastro e a redefinição de senha.
      </p>

      <h3>4. Com quem compartilhamos</h3>
      <ul>
        <li><b>Anthropic (Claude):</b> quando você pede uma análise ou sugestão por IA, enviamos os dados relevantes (saúde, treino, composição corporal, objetivos) pra esse serviço processar e gerar o texto. Não enviamos e-mails nem dados de calendário pra IA.</li>
        <li><b>Google e Microsoft:</b> usados só pra você autorizar o acesso à sua própria conta (Gmail, Calendário, OneNote); não repassamos esses dados a mais ninguém.</li>
        <li><b>Fontes públicas sem dado pessoal:</b> Banco Central, Yahoo Finance e Open-Meteo são consultados só pra trazer cotações e previsão do tempo públicas — nenhum dado seu é enviado a eles.</li>
      </ul>
      <p>Não vendemos, alugamos nem compartilhamos seus dados para fins de publicidade.</p>

      <h3>5. Onde os dados ficam armazenados</h3>
      <p>
        Em um servidor próprio (Oracle Cloud, região São Paulo), sem uso de
        serviços de nuvem de terceiros para armazenamento. Aplicamos medidas
        técnicas razoáveis — senha com hash, conexão HTTPS, sessão via cookie
        seguro — mas, por ser um projeto em crescimento, ainda não aplicamos
        criptografia adicional em repouso para tokens de conexão e chaves de
        API armazenadas; isso está sendo avaliado conforme o app cresce.
      </p>

      <h3>6. Seus direitos</h3>
      <p>
        Você pode pedir a qualquer momento, pelo e-mail{' '}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>: acesso aos
        seus dados, correção, exclusão da conta e de todos os dados
        associados, ou exportação em formato legível. Atendemos esses pedidos
        em até 15 dias.
      </p>

      <h3>7. Retenção</h3>
      <p>
        Seus dados ficam armazenados enquanto sua conta existir. Ao pedir
        exclusão, removemos seus dados em até 30 dias.
      </p>

      <h3>8. Menores de idade</h3>
      <p>O Life Assistant não é destinado a menores de 18 anos.</p>

      <h3>9. Alterações desta política</h3>
      <p>
        Podemos atualizar esta política conforme o app evolui. A data no topo
        desta página sempre mostra a versão mais recente.
      </p>
    </div>
  );
}

export function PrivacyPolicyModal({ onClose }) {
  return (
    <div className="pp-backdrop" onClick={onClose}>
      <div className="pp-modal" onClick={(e) => e.stopPropagation()}>
        <div className="pp-modal-head">
          <h2>Política de Privacidade</h2>
          <button className="pp-close" onClick={onClose} aria-label="Fechar">✕</button>
        </div>
        <div className="pp-modal-body">
          <PrivacyPolicyContent />
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyContent;
